"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuranceProviderSelectInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var insurance_providers_1 = require("../../hooks/insurance-providers");
var InsuranceProviderOptions;
(function (InsuranceProviderOptions) {
    InsuranceProviderOptions["CARRIER"] = "Carrier";
    InsuranceProviderOptions["THIRD_PARTY"] = "ThirdParty";
})(InsuranceProviderOptions || (InsuranceProviderOptions = {}));
/**
 * Take an array of providers and turn them into an array of options for a select input.
 */
function getProviderOptions(providers) {
    var map = new Map();
    providers.forEach(function (provider) {
        map.set(provider.id, provider);
    });
    var uniqueProviders = Array.from(map.values());
    var sorted = sortInsuranceProvidersByName(uniqueProviders);
    return sorted.map(function (provider) { return ({
        label: provider.name,
        value: provider.id,
    }); });
}
/**
 * Take an object of providers and create the option groups for use in a select input.
 */
function formatInsuranceProviderOptions(insuranceProviders, filter) {
    var carrierOptions = getProviderOptions(insuranceProviders.carriers);
    var thirdPartyOptions = getProviderOptions(insuranceProviders.thirdParties);
    if (filter === InsuranceProviderOptions.CARRIER) {
        return [
            {
                label: 'Carriers',
                options: carrierOptions,
            },
        ];
    }
    if (filter === InsuranceProviderOptions.THIRD_PARTY) {
        return [
            {
                label: 'Program administrators and wholesalers',
                options: thirdPartyOptions,
            },
        ];
    }
    return [
        {
            label: 'Carriers',
            options: carrierOptions,
        },
        {
            label: 'Program administrators and wholesalers',
            options: thirdPartyOptions,
        },
    ];
}
/**
 * Find a single provider by id in an object of providers.
 */
function findInsuranceProviderById(id, insuranceProviders) {
    var insuranceProvider = __spreadArray(__spreadArray([], insuranceProviders.carriers, true), insuranceProviders.thirdParties, true).find(function (provider) { return provider.id === id; });
    return insuranceProvider;
}
/**
 * Sort an array of insurance providers by their name.
 */
function sortInsuranceProvidersByName(insuranceProviders) {
    var clonedInsuranceProviders = insuranceProviders.slice();
    return clonedInsuranceProviders.sort(function (providerA, providerB) {
        var nameA = providerA.name.toLowerCase();
        var nameB = providerB.name.toLowerCase();
        if (nameA > nameB) {
            return 1;
        }
        if (nameA < nameB) {
            return -1;
        }
        return 0;
    });
}
/**
 * Render a select input that will load the available insurance providers.
 */
function InsuranceProviderSelectInput(props) {
    var onChange = props.onChange, value = props.value, disabled = props.disabled, name = props.name, key = props.key, filter = props.filter, placeholder = props.placeholder, _a = props.suspense, suspense = _a === void 0 ? false : _a;
    var _b = (0, insurance_providers_1.useInsuranceProviders)({
        suspense: suspense,
    }), insuranceProviderData = _b.data, insuranceProviderError = _b.error;
    // Throw the error during render time so that it is caught be the ErrorBoundary
    if (insuranceProviderError) {
        throw insuranceProviderError;
    }
    var insuranceProviders = (insuranceProviderData &&
        insuranceProviderData.insuranceProviders) || {
        carriers: [],
        thirdParties: [],
    };
    return (react_1.default.createElement(core_ui_1.AdvancedSelectInput, { key: "".concat(key, "-").concat(value && value.id), name: name, placeholder: placeholder || 'Select a carrier, program administrator, or wholesaler', disabled: !!insuranceProviderError || !insuranceProviderData || disabled, onChange: function (id) { return onChange(findInsuranceProviderById(id, insuranceProviders)); }, value: value && value.id, options: formatInsuranceProviderOptions(insuranceProviders, filter) }));
}
exports.InsuranceProviderSelectInput = InsuranceProviderSelectInput;
